<template>
	<div v-if="lat && lon">
		<gmap-map
			ref="gmap"
			:center="position"
			:zoom="16"
			map-type-id="roadmap"
			style="width: 100%; height: 300px"
			:options="mapOptions"
		>
			<gmap-marker
				:position="position"
				:clickable="true"
				:draggable="true"
				@click="center = { lat: 10, lng: 10 }"
				@dragend="dragEnd"
			></gmap-marker>
		</gmap-map>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	inject: ["validate", "form"],
	props: {
		latName: {
			type: String,
			required: true
		},
		lonName: {
			type: String,
			required: true
		}
	},
	computed: {
		...mapGetters({
			mapOptions: "mapOptions"
		}),
		position() {
			return {
				lat: this.lat,
				lng: this.lon
			};
		},
		lat() {
			return this.$store.getters.formFieldValue(this.form, this.latName);
		},
		lon() {
			return this.$store.getters.formFieldValue(this.form, this.lonName);
		}
	},
	beforeMount() {
		this.$store.commit("form_field_register", {
			form: this.form,
			field: this.latName
		});
		this.$store.commit("form_field_register", {
			form: this.form,
			field: this.lonName
		});
	},
	beforeDestroy() {
		this.$store.commit("form_field_unregister", {
			form: this.form,
			field: this.latName
		});
		this.$store.commit("form_field_unregister", {
			form: this.form,
			field: this.lonName
		});
	},
	methods: {
		dragEnd(res) {
			this.$store.commit("form_field_leave", {
				form: this.form,
				field: this.latName,
				value: res.latLng.lat()
			});
			this.$store.commit("form_field_leave", {
				form: this.form,
				field: this.lonName,
				value: res.latLng.lng()
			});
		}
	}
};
</script>

<style lang="scss" scoped></style>
